/**
 * ANNOUNCE CART ITEM UPDATE // Announces cart item update to screen readers
 */
function announceCartItemUpdate(qty) {
  // Create a visually hidden element to announce the update
  var updateAnnouncement = document.createElement('div');
  updateAnnouncement.textContent = 'Cart item quantity updated to ' + qty;
  updateAnnouncement.setAttribute('role', 'alert');
  updateAnnouncement.setAttribute('aria-live', 'polite');
  updateAnnouncement.setAttribute('aria-atomic', 'true');
  updateAnnouncement.style.position = 'absolute';
  updateAnnouncement.style.left = '-9999px';
  updateAnnouncement.style.width = '1px';
  updateAnnouncement.style.height = '1px';
  updateAnnouncement.style.overflow = 'hidden';
  
  // Append the announcement element to the document body
  document.body.appendChild(updateAnnouncement);
  
  // Remove the announcement element after a short delay
  setTimeout(function() {
    if (document.body.contains(updateAnnouncement)) {
      document.body.removeChild(updateAnnouncement);
    }
  }, 1000); // Adjust the delay as needed
}

// Make function globally accessible
window.announceCartItemUpdate = announceCartItemUpdate;

